/**
 * Иконочный набор GTO CONNECT.
 * Геометрия строится на тех же принципах, что и знак: скруглённые
 * окончания, постоянная толщина штриха, минимум деталей.
 */

const PATHS: Record<string, string> = {
  mic: 'M12 3.5a3 3 0 0 1 3 3v5a3 3 0 0 1-6 0v-5a3 3 0 0 1 3-3ZM5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21M8.5 21h7',
  micOff:
    'M15 5.9V6.5a3 3 0 0 0-5.5-1.65M9 9.6v1.9a3 3 0 0 0 4.7 2.47M5.5 11a6.5 6.5 0 0 0 10 5.5M18.5 11v.5M12 17.5V21M8.5 21h7M3.5 3.5l17 17',
  cam: 'M4 7.5A2.5 2.5 0 0 1 6.5 5h6A2.5 2.5 0 0 1 15 7.5v9a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 4 16.5v-9ZM15 10.5l4.2-2.6a.6.6 0 0 1 .92.5v7.2a.6.6 0 0 1-.92.5L15 13.5',
  camOff:
    'M4 7.5A2.5 2.5 0 0 1 6.5 5h4M15 9V7.5A2.5 2.5 0 0 0 12.5 5M15 10.5l4.2-2.6a.6.6 0 0 1 .92.5v7.2a.6.6 0 0 1-.36.55M4 11v5.5A2.5 2.5 0 0 0 6.5 19h6a2.5 2.5 0 0 0 2.36-1.7M3.5 3.5l17 17',
  screen:
    'M3.5 6a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v8.5a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2V6ZM8.5 20.5h7M12 16.5v4M12 12.5V7.5M12 7.5 9.5 10M12 7.5 14.5 10',
  screenOff:
    'M3.5 6a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v8.5a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2V6ZM8.5 20.5h7M12 16.5v4',
  chat: 'M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v7a2.5 2.5 0 0 1-2.5 2.5H10l-4.4 3.4a.6.6 0 0 1-.97-.48V16h.37A1.5 1.5 0 0 1 4 14.5v-8Z',
  people:
    'M9 11.5a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5ZM2.5 19.5a6.5 6.5 0 0 1 13 0M16 5.4a3.25 3.25 0 0 1 0 6.2M17.5 14.2a6.5 6.5 0 0 1 4 5.3',
  leave:
    'M2.7 10.4c5.1-3.6 13.5-3.6 18.6 0 1 .7 1.2 2.1.5 3l-1.3 1.6a1.6 1.6 0 0 1-2 .4l-2.4-1.3a1.6 1.6 0 0 1-.83-1.5l.1-1.5c-2.2-.7-4.5-.7-6.7 0l.1 1.5a1.6 1.6 0 0 1-.83 1.5l-2.4 1.3a1.6 1.6 0 0 1-2-.4L2.2 13.4a2 2 0 0 1 .5-3Z',
  settings:
    'M12 15.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4ZM19.6 14.4a1.5 1.5 0 0 0 .3 1.65l.05.06a1.8 1.8 0 1 1-2.55 2.55l-.06-.06a1.5 1.5 0 0 0-1.65-.3 1.5 1.5 0 0 0-.9 1.37v.17a1.8 1.8 0 1 1-3.6 0v-.09a1.5 1.5 0 0 0-.98-1.37 1.5 1.5 0 0 0-1.65.3l-.06.06a1.8 1.8 0 1 1-2.55-2.55l.06-.06a1.5 1.5 0 0 0 .3-1.65 1.5 1.5 0 0 0-1.37-.9h-.17a1.8 1.8 0 1 1 0-3.6h.09a1.5 1.5 0 0 0 1.37-.98 1.5 1.5 0 0 0-.3-1.65l-.06-.06A1.8 1.8 0 1 1 8.4 3.06l.06.06a1.5 1.5 0 0 0 1.65.3h.07a1.5 1.5 0 0 0 .9-1.37v-.17a1.8 1.8 0 1 1 3.6 0v.09a1.5 1.5 0 0 0 .9 1.37 1.5 1.5 0 0 0 1.65-.3l.06-.06a1.8 1.8 0 1 1 2.55 2.55l-.06.06a1.5 1.5 0 0 0-.3 1.65v.07a1.5 1.5 0 0 0 1.37.9h.17a1.8 1.8 0 1 1 0 3.6h-.09a1.5 1.5 0 0 0-1.37.9Z',
  copy: 'M9 9.5A2.5 2.5 0 0 1 11.5 7h7A2.5 2.5 0 0 1 21 9.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 9 16.5v-7ZM15 7V5.5A2.5 2.5 0 0 0 12.5 3h-7A2.5 2.5 0 0 0 3 5.5v7A2.5 2.5 0 0 0 5.5 15H7',
  check: 'M4.5 12.5 9.5 17.5 19.5 6.5',
  // Звено цепи: две скобы под 45° и перемычка между ними.
  link: 'M9.7 14.3 14.3 9.7M11 6.5l1.9-1.9a3.6 3.6 0 0 1 5.1 5.1L16.1 11.6M12.9 17.5 11 19.4a3.6 3.6 0 0 1-5.1-5.1L7.8 12.4',
  share:
    'M17.5 8.6a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2ZM6.5 14.6a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2ZM17.5 20.6a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2ZM8.8 10.8l6.4-3.2M8.8 13.2l6.4 3.2',
  close: 'M6 6l12 12M18 6 6 18',
  send: 'M4 12 20.5 4.5 13 21l-2.2-6.8L4 12Z',
  plus: 'M12 5v14M5 12h14',
  arrowRight: 'M4.5 12h15M13.5 6l6 6-6 6',
  pin: 'M9 4h6l-.8 5.4 3.3 3.1H12v6.5l-1 2-1-2V12.5H6.5l3.3-3.1L9 4Z',
  alert: 'M12 8.5v4.5M12 16.6v.1M10.3 4.2 2.6 17.5A2 2 0 0 0 4.3 20.5h15.4a2 2 0 0 0 1.7-3L13.7 4.2a2 2 0 0 0-3.4 0Z',
  refresh:
    'M20 11.5A8 8 0 0 0 6.3 6.3L4 8.5M4 4v4.5h4.5M4 12.5a8 8 0 0 0 13.7 5.2L20 15.5M20 20v-4.5h-4.5',
  shield:
    'M12 3 4.5 6v6c0 4.4 3 7.9 7.5 9 4.5-1.1 7.5-4.6 7.5-9V6L12 3Z M9.2 12.2l2 2 3.6-4',
  volume: 'M4 9.5h3L11 6v12L7 14.5H4v-5ZM14.5 9.5a3.5 3.5 0 0 1 0 5M17.5 7a7 7 0 0 1 0 10',
  logout: 'M9 4.5H6.5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2H9M15 8l4 4-4 4M19 12H9',
  calendar:
    'M4 7.5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-11ZM8 3.5v4M16 3.5v4M4 10.5h16M8.5 14.5h2M13.5 14.5h2M8.5 17.5h2',
  clock: 'M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17ZM12 7.5V12l3 2',
  sound: 'M4 9.5h3L11 6v12L7 14.5H4v-5ZM15 8.5a5 5 0 0 1 0 7',
  waves: 'M3 12h2M8 7.5v9M12 4.5v15M16 8.5v7M20 11h1',
  // Запись: точка в кольце. Остановка — квадрат в том же кольце.
  present:
    'M3 4.5h18M5 4.5v8.5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4.5M12 15v3.5M9 21l3-2.5 3 2.5M8.5 11.5l2.6-3.2 2 1.9 2.4-3.2',
  record: 'M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17ZM12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z',
  recordStop: 'M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17ZM9.5 9.5h5v5h-5z',
  // Стрелки в углы — «развернуть», и обратно к центру — «свернуть».
  maximize: 'M14.5 4.5H19.5V9.5M19.5 4.5 14 10M9.5 19.5H4.5V14.5M4.5 19.5 10 14',
  minimize: 'M19 9.5H14V4.5M14 9.5 19.5 4M5 14.5H10V19.5M10 14.5 4.5 20',
};

/** Иконки, которые читаются только заливкой, без штриха. */
const FILLED = new Set(['leave', 'send', 'pin']);

export type IconName = keyof typeof PATHS;

export function Icon({
  name,
  size = 20,
  className,
}: {
  name: IconName;
  size?: number;
  className?: string;
}) {
  const filled = FILLED.has(name);

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
      focusable="false"
    >
      <path
        d={PATHS[name]}
        stroke={filled ? 'none' : 'currentColor'}
        fill={filled ? 'currentColor' : 'none'}
        strokeWidth={1.7}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
